import { Drawer } from 'antd'
import classNames from 'classnames'
import CloseBlueIcon from 'components/atoms/icons/CloseBlueIcon'
import FaqComponent from 'components/organisms/MainHeader/Faq'
import React, { ComponentProps } from 'react'

import { RightDrawerClass } from './styles'

type Props = ComponentProps<typeof Drawer>

const RightDrawer: React.FC<Props> = ({
  visible = false,
  mask = false,
  title,
  children,
  className,
  onClose,
  ...rest
}) => {
  const tooltipTitle = (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', height: 45, marginRight: 10 }}>
        <FaqComponent isShowFullOptions={false} />
      </div>
      <div className="divider" style={{ height: 1, background: '#D4D8DD', width: '100%' }} />
      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        <label style={{ fontSize: 18, height: 50, marginLeft: 40, paddingTop: 12 }}>{title}</label>
      </div>
    </>
  )

  return (
    <Drawer
      {...rest}
      title={tooltipTitle}
      placement="right"
      closable
      onClose={onClose}
      visible={visible}
      className={classNames('app-right-drawer', RightDrawerClass, className)}
      destroyOnClose
      mask={mask}
      closeIcon={
        <div>
          <CloseBlueIcon />
        </div>
      }
    >
      <div style={{ maxHeight: '100%' }}>{children}</div>
    </Drawer>
  )
}

export default RightDrawer
